var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:`logo ${_vm.small ? 'small' : ''}`,attrs:{"href":"/espace-client"}},[(_vm.small)?_c('img',{attrs:{"src":_vm.logoSmallUrl,"alt":_vm.$publicDico.header.logo.baseline}}):_c('img',{attrs:{"src":_vm.logoUrl,"alt":_vm.$publicDico.header.logo.baseline}})])
}
var staticRenderFns = []

export { render, staticRenderFns }